import { render, staticRenderFns } from "./AssignTelephoneTask.vue?vue&type=template&id=9fb7b5b6&scoped=true"
import script from "./AssignTelephoneTask.vue?vue&type=script&lang=js"
export * from "./AssignTelephoneTask.vue?vue&type=script&lang=js"
import style0 from "./AssignTelephoneTask.vue?vue&type=style&index=0&id=9fb7b5b6&prod&lang=scss&scoped=true"
import style1 from "./AssignTelephoneTask.vue?vue&type=style&index=1&id=9fb7b5b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb7b5b6",
  null
  
)

export default component.exports